import { render, staticRenderFns } from "./MercadolibreList.vue?vue&type=template&id=839554a6"
import script from "./MercadolibreList.vue?vue&type=script&lang=js"
export * from "./MercadolibreList.vue?vue&type=script&lang=js"
import style0 from "./MercadolibreList.vue?vue&type=style&index=0&id=839554a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports